import React, { Suspense, useRef, useState, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import ClinicReports from "./Dashboard Widgets/ClinicDashboardTabs/ClinicReports";
import PatientSatisfactionChart from "./Dashboard Widgets/ClinicDashboardTabs/ClinicAnalytics/PatientSatisfactionChart";
import StaffPerformanceChart from "./Dashboard Widgets/ClinicDashboardTabs/ClinicAnalytics/StaffPerformanceChart";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import dayjs from "dayjs";
import ClinicOverview from "./Dashboard Widgets/ClinicDashboardTabs/ClinicOverview";
import {
  useGetAllClinicDashboardQuery,
  useGetDashboardGeneralQuery,
} from "../State/Api/AddClinicInfoApiSlice";
import ClinicStats from "./Dashboard Widgets/ClinicDashboardTabs/ClinicAnalytics/ClinicStats";
import RecentPatients from "./Dashboard Widgets/ClinicDashboardTabs/ClinicAnalytics/RecentPatients";
import TopDoctors from "./Dashboard Widgets/ClinicDashboardTabs/ClinicAnalytics/TopDoctors";
import ScheduleCard from "./Dashboard Widgets/ClinicDashboardTabs/ClinicAnalytics/ScheduleCard";
import ChatbotWidget from "./ChatBotWidget";
import { Modal, Button, Form } from "react-bootstrap";
import PlanExpiryModal from "./ClinicModal/PlanExpiryModal";

function ClinicDashboard({isFetching,isLoading ,isError}) {
  const navigate = useNavigate();
  // State for calendar
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dates, setDates] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [upcoming, setUpcoming] = useState([]);
   const location = useLocation();
  const [showTermsModal, setShowTermsModal] = useState(false);
   useEffect(() => {
    if (location.state?.showTermsModal) {
      setShowTermsModal(true);
    }
  }, [location.state]);

  const [showPlanExpiryModal, setShowPlanExpiryModal] = useState(false);
  const [expiryMessage, setExpiryMessage] = useState("");

  useEffect(() => {
    if (location.state?.showPlanExpiryModal) {
      setExpiryMessage(location.state.expiryMessage || "");
      setShowPlanExpiryModal(true);
    }
  }, [location.state]);
  const termsAccepted=location.state?.termsAccepted;
  const isFirstLogin=location.state?.isFirstLogin;

  const scrollRef = useRef(null);

  const clinicId = localStorage.getItem("userClinicID");

  const today = new Date().toISOString().split("T")[0];

  const {
    data: dashboardData,
    isLoading: isDashboardLoading,
    isError: isDashboardError,
    isSuccess: isDashboardSuccess,
  } = useGetDashboardGeneralQuery(clinicId);

  // Schedule + Upcoming
  const {
    data: scheduleData,
    isLoading: isScheduleLoading,
    isError: isScheduleError,
    isSuccess: isScheduleSuccess,
  } = useGetAllClinicDashboardQuery({
    clinicId,
    appointmentDate: dayjs(selectedDate).format("YYYY-MM-DD"),
  });

  // Generate 3 months of dates
  useEffect(() => {
    const today = new Date();
    const allDates = [];
    for (let i = 0; i < 75; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);
      allDates.push(d);
    }
    setDates(allDates);
  }, []);
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 p-6 animate-pulse">
        <div className="max-w-9xl mx-auto space-y-6">
          {/* Header - ClinicReports */}
          <div className="h-40 bg-gray-300 rounded-lg"></div>

          {/* Top Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[...Array(4)].map((_, i) => (
              <div
                key={i}
                className="h-24 bg-gray-200 rounded-lg shadow-sm"
              ></div>
            ))}
          </div>

          {/* Bottom Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Recent Patients */}
            <div className="h-96 bg-gray-200 rounded-lg"></div>
            {/* Top Doctors */}
            <div className="h-96 bg-gray-200 rounded-lg"></div>
            {/* Schedule Card */}
            <div className="h-96 bg-gray-200 rounded-lg"></div>
          </div>

          {/* Overview */}
          <div className="h-96 bg-gray-300 rounded-lg"></div>
        </div>
      </div>
    );
  }

  if (isDashboardError || isScheduleError) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-red-600">Failed to load dashboard data.</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <style>{`
        .dashboard-container {
  width: 100%;
  max-width: 100%;
}
        .stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 20px; margin-bottom: 20px; }
        .stat-card { position: relative; border-radius: 16px; padding: 15px; background: #fff; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); display: flex; justify-content: space-between; overflow: hidden; }
        .circle-before, .circle-after { content: ''; position: absolute; border-radius: 50%; z-index: 0; }
        .circle-before { width: 120px; height: 120px; top: -40px; right: 70%; }
        .circle-after { width: 200px; height: 200px; bottom: -80px; left: -80px; }
        .stat-content { position: relative; z-index: 1; }
        .stat-card h3 { font-size: 1.8rem; margin: 0; color: #111827; }
         .stat-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
        }
        .stat-title { margin: 4px 0; font-size: 1rem; color: #4b5563; }
        .stat-change { font-size: 0.85rem; }
        .action-buttons { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; align-items: center; }
        .action-btn { background-color: #462860; color: #fff; border: none; padding: 12px 0; border-radius: 8px; font-size: 10px; cursor: pointer; width: 100%; }
        .bottom-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px; }
        .bottom-grid > .card {
          height: 450px; /* fixed height */
         overflow-y: auto; /* vertical scroll for entire card */
            scrollbar-width: none;
         }
           .bottom-grid > .card::-webkit-scrollbar {
           display:none;
           }
          .bottom-grid > .card::-webkit-scrollbar-thumb {
          background-color: rgba(0, 0, 0, 0.2);
           border-radius: 3px;
        }
        .card { background: #fff; border-radius: 12px; padding: 16px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05); }
        .card h4 { color: #f97316; margin-bottom: 10px; }
        .list-item { display: flex; justify-content: space-between; align-items: center; padding: 10px; margin-top: 10px; background: #f9fafc; border-radius: 8px; }
        .badge { background: #ff6600; color: #fff; border-radius: 8px; padding: 5px 10px; font-weight: bold; }
        .hide-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      <PlanExpiryModal
        show={showPlanExpiryModal}
        message={expiryMessage}
        onClose={() => setShowPlanExpiryModal(false)}
      />

      <div className="mb-4">
        <ClinicReports ageandgenderstats={dashboardData?.patientAgeGenderDistribution} appointmentTypes={dashboardData?.appointmentTypeDistribution} revenue={dashboardData?.revenueByDepartment} />
      </div>

      {/* Top Stats */}
      <ClinicStats
        stats={dashboardData?.stats}
        isLoading={isDashboardLoading}
        isSuccess={isDashboardSuccess}
      />

      {/* Bottom Grid */}
      <div className="bottom-grid">
        {/* Recent Patients */}

        <RecentPatients
          patients={dashboardData?.recentPatients || []}
          isLoading={isDashboardLoading}
          isSuccess={isDashboardSuccess}
        />

        {/* Top Doctors */}
        <TopDoctors
          doctors={dashboardData?.topDoctors || []}
          isLoading={isDashboardLoading}
          isSuccess={isDashboardSuccess}
        />

        {/* New Schedule Card */}
        <ScheduleCard
          appointments={scheduleData?.dateWiseAppointments || []}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          dates={dates}
          scrollRef={scrollRef}
        />
      </div>

      <div className="my-5">
        <ClinicOverview
          appointments={dashboardData?.recentAppointments || []}
          monthlyOverview={dashboardData?.yearlyOverview || []}
          isLoading={isDashboardLoading}
          isSuccess={isDashboardSuccess}
        />
      </div>

      <div>
        {/* <ChatbotWidget /> */}
      </div>
     
    </div>
  );
}

export default ClinicDashboard;
